import { render, staticRenderFns } from "./BTabs.vue?vue&type=template&id=42f81d3b&scoped=true&"
import script from "./BTabs.vue?vue&type=script&lang=js&"
export * from "./BTabs.vue?vue&type=script&lang=js&"
import style0 from "./BTabs.vue?vue&type=style&index=0&id=42f81d3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f81d3b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
